import { IconButton, Typography } from '@material-ui/core'
import ShowActionIcon from '@material-ui/icons/Visibility'
import React, { useState } from 'react'

import { RatePlanPolicy } from '../../types/rateplanPolicy'
import RatePlansPoliciesActionModal from './RatePlansPoliciesActionModal'
import useStyles from './styles/RatePlansPoliciesListRow.styles'

interface RatePlansPoliciesListRowProps {
  policiesData: RatePlanPolicy
}
const RatePlansPoliciesListRow: React.FC<RatePlansPoliciesListRowProps> = ({
  policiesData
}) => {
  const classes = useStyles()
  const [actionModalIsOpen, setactionModalIsOpen] = useState<boolean>(false)
  const { from, to, policySet } = policiesData
  return (
    <div className={classes.tableRow}>
      <div className={classes.nameCell}>
        <Typography variant="h4">{policySet.name}</Typography>
      </div>
      <div>
        <Typography variant="body1">{from}</Typography>
      </div>
      <div>
        <Typography variant="body1">{to}</Typography>
      </div>
      <div>
        <IconButton onClick={() => setactionModalIsOpen(true)}>
          <ShowActionIcon />
        </IconButton>
      </div>
      <RatePlansPoliciesActionModal
        isOpen={actionModalIsOpen}
        onClose={() => setactionModalIsOpen(false)}
        data={policySet.policies}
      />
    </div>
  )
}
export default RatePlansPoliciesListRow
